import './styles.css';

import React from 'react';
import classname from '@search/classname/src';
import { Typography } from '@vtblife/uikit';

import { SellerType } from '@search/filter-enums/enums/SellerType';
import { getAuthorDescription } from '../AuthorBadge/AuthorBadge';
import { IconCompany } from './icons/IconCompany';
import { IconMan } from './icons/IconMan';
import { IconDeveloper } from './icons/IconDeveloper';

const cn = classname.bind(null, 'CardAuthorBadge');

export type SellerTypeEnum = 'UNKNOWN' | 'OWNER' | 'AGENT' | 'AGENCY' | 'DEVELOPER' | 'PIT' | 'AGGREGATOR';

export function SellerIcon({
    sellerType,
    iconSrc
}: {
    sellerType: SellerType | SellerTypeEnum;
    iconSrc?: string;
}) {
    let icon = <IconCompany />;

    if (iconSrc) {
        icon = (
            <img
                alt='логотип'
                style={{
                    width: '100%',
                    objectFit: 'contain'
                }}
                src={iconSrc}
                crossOrigin='anonymous'
            />
        );
    } else {
        if (sellerType === SellerType.DEVELOPER || sellerType === 'DEVELOPER') icon = <IconDeveloper />;
        if (sellerType === SellerType.OWNER || sellerType === 'OWNER') icon = <IconMan />;
    }

    return (
        <CircleIconWrapper>{icon}</CircleIconWrapper>
    );
}

export function CircleIconWrapper({
    children,
    color,
    containerRef
}: {
    color?: string;
    containerRef?: React.RefCallback<HTMLElement>;
    children: React.ReactNode;
}) {
    return (<div className={cn('avatar')} style={{ backgroundColor: color }} ref={containerRef}>
        {children}
    </div>);
}

export function SellerText({
    organizationName,
    name,
    sellerType,
    nameClass,
    isMobile
}: {
    nameClass?: string;
    sellerType: SellerType | SellerTypeEnum;
    name?: string;
    organizationName?: string | null;
    isMobile?: boolean;
}) {
    const orgName = getAuthorDescription({ category: sellerType, organizationName });

    return (
        <div className={cn('seller')}>
            {orgName && (
                <Typography
                    variant={isMobile ? 'secondary-alone' : undefined}
                    color='black-400'
                >
                    {orgName}
                </Typography>
            )}
            {name && (
                <div className={cn('name', undefined, nameClass)}>
                    <Typography
                        variant={isMobile ? 'primary' : undefined}
                        bold={! isMobile}
                    >
                        {name}
                    </Typography>
                </div>
            )}
        </div>
    );
}

export const CardAuthorBadge: React.FC<{
    name: string;
    organizationName: string;
    category: SellerType;
    iconSrc?: string;
    isMobile?: boolean;
    url?: string;
}> = ({
    iconSrc,
    category,
    name,
    organizationName,
    isMobile,
    url
}) => {
    const tag = url ? 'a' : 'div';

    return React.createElement(
        tag,
        {
            className: cn(null, { isMobile }),
            ...(url && { target: '_blank' }),
            ...(url && { href: url }),
        },
        <>
            <SellerText
                name={name}
                organizationName={organizationName}
                sellerType={category}
                isMobile={isMobile}
                nameClass={cn('name_wrap', { isMobile })}
            />
            <div style={{
                [isMobile ? 'marginRight' : 'marginLeft']: '16px'
            }}>
                <SellerIcon iconSrc={iconSrc} sellerType={category} />
            </div>
        </>
    );
};
